import * as types from './action-types';
import { defineAction } from 'store/common/action-helpers';

export const getClaimantPercentile = {
  start: payload => defineAction(types.ClAIMANT_PERCENTILE.START, payload),
  success: payload => defineAction(types.ClAIMANT_PERCENTILE.SUCCESS, payload),
  failure: payload => defineAction(types.ClAIMANT_PERCENTILE.FAILURE, payload),
};
